import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import Modal from 'components/Modal';
import { useDispatch } from 'react-redux';
import { deleteTile } from 'store/slices/offlineTilesSlice';
import * as S from './styles';

export default function DeleteConfirmation({ isOpen, onClose, mapName, mapId, setDeletingId, onConfirmDelete }) {
	const dispatch = useDispatch();

	const handleConfirm = async () => {
		if (!mapId) return;

		try {
			setDeletingId(mapId);

			// aguarda o resultado da exclusão
			await dispatch(deleteTile(mapId)).unwrap();

			// só remove do mapa se deu certo
			onConfirmDelete(mapId);
		} catch (err) {
			// erro já está no slice, não precisa fazer nada extra
			console.error(err);
		} finally {
			setDeletingId(null);
			onClose(); // fecha o modal
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			setIsOpen={onClose}
			textBtn="Excluir"
			geralFunction={handleConfirm}
			styleContent={S.modalStyle}
		>
			<S.Content>
				<S.IconWrapper>
					<FiAlertTriangle />
				</S.IconWrapper>
				<S.Title>Confirmar exclusão</S.Title>
				<S.Message>
					Tem certeza que deseja excluir o mapa <strong>{mapName}</strong>?
					<br />
					Esta ação não pode ser desfeita.
				</S.Message>
			</S.Content>
		</Modal>
	);
}
